import type { User } from '@saniplus/contracts';

/**
 * « Nom, Prénom » in the register, « Prénom Nom » in prose.
 *
 * A helper rather than JSX, because the grid cell and the dialog title need
 * the same string and a comma inlined in JSX is a literal the copy lint
 * (rightly) refuses.
 *
 * Both forms **trim**, the way the API does (`me-punches.service.ts`): a row
 * whose `lastName` is empty otherwise renders with a dangling space, and the
 * two halves of the product then disagree about the same person's name.
 */
export function formatNameLast(user: Pick<User, 'firstName' | 'lastName'>): string {
  return `${user.lastName}, ${user.firstName}`.trim();
}

export function formatName(user: Pick<User, 'firstName' | 'lastName'>): string {
  return `${user.firstName} ${user.lastName}`.trim();
}
